import { connect_device, exploit_gabb, get_autoconnect, godo, monitor_usb, pair_device, select_existing, send_to_device, set_autoconnect, disconnect, install_app, run_user_command, navigate_in_time, start_wifi_adb, stop_wifi_adb, log } from "./common";
import * as bootstrap from "bootstrap";

const runner = document.querySelector("#runner");

document.getElementById("pair").addEventListener("click", async () => {
  await pair_device();
});

document.getElementById("start").addEventListener("click", async () => {
  await connect_device();
});

document.getElementById("disconnect").addEventListener("click", async () => {
  await disconnect();
});

document.querySelector("#test_cmd")?.addEventListener("click", async () => {
  const command_output = (await godo("ls /", true));
  console.log(command_output)
  console.log(command_output.stderr)
  console.log(command_output.stdout)
});

document.querySelector("#exploit").addEventListener("click", async () => {
  await exploit_gabb();
});

document.querySelector("#install").addEventListener("click", async () => {
  const file_input = document.querySelector("#apk");
  const file = file_input.files[0];
  const user_select = document.querySelector("#users");
  install_app(file, user_select.value);
});

document.querySelector("#send").addEventListener("click", async () => {
  const file = document.querySelector("#sender").files[0];
  send_to_device(file);
})

document.querySelector("#startwifi").addEventListener("click", async () => {
  await start_wifi_adb();
});

document.querySelector("#stopwifi").addEventListener("click", async () => {
  await stop_wifi_adb();
})

document.querySelector("#run").addEventListener("click", async () => {
  await run_user_command(runner);
});

document.querySelector("#runner").addEventListener("keyup", async ev => {
  // console.log(ev.keyCode);
  if (ev.keyCode == 13) {
    await run_user_command(runner);
  } else if (ev.keyCode == 38) {
    navigate_in_time(-1, runner);
  } else if (ev.keyCode == 40) {
    navigate_in_time(1, runner);
  }
  
});

const device_list = document.querySelector("#devices");
device_list.addEventListener("change", () => {
  select_existing(device_list.value);
});

const autoconnect = document.querySelector("#autoconnect");
autoconnect.checked = get_autoconnect();
autoconnect.addEventListener("change", () => {
  set_autoconnect(autoconnect.checked);
});

function monitor() {
  
}

document.querySelector("#startshizuku").addEventListener("click", async () => {
  try {
    await godo(`sh /sdcard/Android/data/moe.shizuku.privileged.api/start.sh`);
  } catch (e) {
    log("Old start method failed, trying new start method...");
    let res = await godo("dumpsys package moe.shizuku.privileged.api", false, true);
    const basePath = res.stdout.split("resourcePath=")[1].split("\n")[0];
    await godo(`${basePath}/lib/arm/libshizuku.so`);
  }
});

(() => {
  function popper(event) {
    document.querySelector(".imagepreview").src = event.target.parentElement.querySelector("img").src;
    new bootstrap.Modal(document.querySelector("#imagemodal")).show();
  }
  for (const pop of document.querySelectorAll(".pop")) {
    pop.addEventListener("click", popper);
  }
})();



monitor_usb(device_list, monitor);